"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _types = require("../../actions/types");
var _ReadinessCheck = require("../../constants/ReadinessCheck");
var _utils = require("../../actions/ReadinessCheck/utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = exports.initialState = {
  speaker: _ReadinessCheck.CHECKING,
  camera: _ReadinessCheck.CHECKING,
  microphone: _ReadinessCheck.CHECKING,
  connectivity: _ReadinessCheck.CHECKING,
  screenShare: _ReadinessCheck.WAITING,
  device: (0, _utils.isMobileDevice)() ? _ReadinessCheck.FAILED : _ReadinessCheck.PASSED,
  browser: (0, _utils.isChromiumBased)() ? _ReadinessCheck.PASSED : _ReadinessCheck.FAILED
};
function readinessCheck() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_READINESS_CHECK) {
    var newState = _objectSpread(_objectSpread({}, state), action.payload);
    return newState;
  }
  if (action.type === "".concat(_types.BROADCAST_RUN_READINESS_CHECK, "_SUCCESS")) {
    return action.payload;
  }
  return state;
}
var _default = exports["default"] = readinessCheck;